import { useEffect } from "react";
import Lenis from "lenis";

export default function useSmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.5,
      easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: "vertical",
      smooth: true,
      wheelMultiplier: 1,
      touchMultiplier: 1,
      infinite: false,
      smoothTouch: false,
      touchInertiaMultiplier: 0,
      smoothWheel: true,
      ignoreElements: el => {
        return el.hasAttribute("data-lenis-prevent") || el.closest("[data-lenis-prevent]") !== null;
      },
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);
}
